// extracted by mini-css-extract-plugin
export default {"categoryText":"categoryNode_categoryText__VW1Hc","active":"categoryNode_active__nMR8s","inactive":"categoryNode_inactive__G+JpA"};